/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'trackunit': {
    width: 16,
    height: 16,
    viewBox: '0 0 158.69 173.98',
    data: '<g data-name="Layer 2"><path pid="0" _fill="inherit" d="M127 94.83v15.78a31.82 31.82 0 11-63.64 0V94.83H31.77v15.78a63.38 63.38 0 00126.75 0V94.83zM94.92 55.22h-31.6V7.6H31.77v47.62H0v31.55h94.92V55.22z"/><path pid="1" _fill="#f94235" d="M95.35 7.71L109.29 0l13.95 7.71v15.35l-13.95 7.72-13.94-7.72zM130.8 7.71L144.74 0l13.95 7.71v15.35l-13.95 7.72-13.94-7.72zM127.02 60.62l-13.95-7.72V37.55l13.95-7.79 13.95 7.72V52.9l-13.95 7.72"/></g>'
  }
})
